import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { user } from "../../store/reducers/reducerUser";
import {
  getTop10Players,
  getTop100Players,
  getOwners,
  getTopGuilds,
  getCastleSiegeWinners,
  getCastleRegisteredGuilds,
  getPlayersOnline,
  getPlayerStats,
  getEventTimes,
} from "../../store/reducers/reducerWeb";
import LangBar from "../layout/LangBar";
import SiteNav from "../layout/SiteNav";
import SiteFooter from "../layout/SiteFooter";
import Dashboard from "../Dashboard/Dashboard";
import "./main.scss";

function Main() {
  const dispatch = useDispatch();
  const location = useLocation();
  const isHome = location.pathname === "/";

  useEffect(() => {
    dispatch(user());
    dispatch(getTop10Players());
    dispatch(getTop100Players());
    dispatch(getOwners());
    dispatch(getTopGuilds());
    dispatch(getCastleSiegeWinners());
    dispatch(getCastleRegisteredGuilds());
    dispatch(getPlayersOnline());
    dispatch(getPlayerStats());
    dispatch(getEventTimes());

    const tick = setInterval(() => {
      dispatch(getPlayersOnline());
      dispatch(getEventTimes());
    }, 30000);

    return () => clearInterval(tick);
  }, [dispatch]);

  return (
    <div id="newCur" className={`mu-shell${isHome ? " mu-shell--home" : " mu-shell--page"}`}>
      <div className="mu-shell__content">
        <LangBar />
        <SiteNav />
        <div className="mu-page">
          <Dashboard />
        </div>
        <SiteFooter />
      </div>
    </div>
  );
}

export default Main;
